import FormFieldFactory from './field/form_field_factory';
import FormActionFactory from "./action/form_action_factory";
import FormGroupFactory from "./group/form_group_factory";

import Behavior from 'behaviors_engine/models/behavior';

export default class FormStoreItem {
	_id;
	_fields;
	_errors;
	_actions;
	_behaviors;
	_initialValuesDataStoreRoute;
	_waitingForAction;
	_readOnly;
	_definitionURL;
	_definitionParams;
	_formLoaded;
	_formLoadedWithErrors;
	_isMobile;
	_loadOnInit;
	_fieldsGroupings;
	_groups;
	_dataPrintEnabled;
	_isECMLicenseFull;
	_initialValues;
	_flagError;

	constructor(storeItemProps = {}) {
		Object.keys(storeItemProps)
		.forEach((propName) => this[propName] = storeItemProps[propName]);

		this._actions = this._buildFormActions(storeItemProps.actions);
		this._fields = this._buildFormFields(storeItemProps.fields);
		this._groups = this._buildFormGroups(storeItemProps.groups);
		this._behaviors = this._buildFormBehaviors(storeItemProps.behaviors);
	}

	_buildFormFields(fields) {
		return fields ? fields.map((field) => FormFieldFactory.create(Object.assign({ formId: this._id }, field))) : [];
	}

	_buildFormActions(actions) {
		return actions ? actions.map((action) => FormActionFactory.create(Object.assign({ formId: this._id }, action))) : [];
	}

	_buildFormBehaviors(behaviors) {
		return behaviors ? behaviors.map((behavior) => new Behavior(behavior)) : [];
	}

	_buildFormGroups(groups) {
		return groups ? groups.map((group) => FormGroupFactory.create(Object.assign({ formId: this._id }, group))) : [];
	}

	get id() {
		return this._id;
	}

	set id(value) {
		this._id = value;
	}

	get fields() {
		return this._fields;
	}

	set fields(fields) {
		this._fields = this._buildFormFields(fields);
	}

	get groups() {
		return this._groups;
	}

	set groups(groups) {
		this._groups = this._buildFormGroups(groups);
	}

	get errors() {
		return this._errors;
	}

	set errors(value) {
		this._errors = value;
	}

	get actions() {
		return this._actions;
	}

	set actions(actions) {
		this._actions = this._buildFormActions(actions);
	}

	get behaviors() {
		return this._behaviors;
	}

	set behaviors(behaviors) {
		this._behaviors = this._buildFormBehaviors(behaviors);
	}

	get initialValuesDataStoreRoute() {
		return this._initialValuesDataStoreRoute;
	}

	set initialValuesDataStoreRoute(value) {
		this._initialValuesDataStoreRoute = value;
	}

	get waitingForAction() {
		return this._waitingForAction;
	}

	set waitingForAction(value) {
		this._waitingForAction = value;
	}

	get readOnly() {
		return this._readOnly;
	}

	set readOnly(value) {
		this._readOnly = value;
	}

	get definitionURL() {
		return this._definitionURL;
	}

	set definitionURL(value) {
		this._definitionURL = value;
	}

	get definitionParams() {
		return this._definitionParams;
	}

	set definitionParams(value) {
		this._definitionParams = value;
	}

	get formLoaded() {
		return this._formLoaded;
	}

	set formLoaded(value) {
		this._formLoaded = value;
	}

	get formLoadedWithErrors() {
		return this._formLoadedWithErrors;
	}

	set formLoadedWithErrors(value) {
		this._formLoadedWithErrors = value;
	}

	get isMobile() {
		return this._isMobile;
	}

	set isMobile(value) {
		this._isMobile = value;
	}

	get isECMLicenseFull(){
		return this._isECMLicenseFull;
	}

	set isECMLicenseFull(value){
		this._isECMLicenseFull = value;
	}

	get loadOnInit() {
		return this._loadOnInit;
	}

	set loadOnInit(value) {
		this._loadOnInit = value;
	}

	get fieldsGroupings() {
		return this._fieldsGroupings;
	}

	set fieldsGroupings(value) {
		this._fieldsGroupings = value;
	}

	get dataPrintEnabled() {
		return this._dataPrintEnabled;
	}

	set dataPrintEnabled(value) {
		this._dataPrintEnabled = value;
	}

	get initialValues() {
		return this._initialValues;
	}

	set initialValues(value) {
		this._initialValues = value;
	}

	get flagError() {
		return this._flagError;
	}

	set flagError(value) {
		this._flagError = value;
	}
}
